import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const departments = [
    { name: "परिचय ", id: "about-diploma" },
    { name: "उद्देश्य", id: "objectives" }, // Added Objectives
    { name: "समय सारिणी", id: "timetable" },
    { name: "उपलब्धियां", id: "achievements" },
    { name: "सम्पर्क", id: "contact" }
];

const contentData = {
    "about-diploma": (
        <>
            <p>भारतीय वास्तुशास्त्र भवन आदि की समग्र निर्माण विधि एवं प्रक्रिया का प्रतिपादक शास्त्र है । इस शास्त्र की उत्पत्ति स्थापत्यवेद से हुई, जो अथर्ववेद के उपवेद के रूप में प्रसिद्ध है । यह स्थापत्य विज्ञान है, जो प्रकृति के पाँच मूलभूत तत्त्वों (पृथिवी, जल, तेज, वायु एवं आकाश) का संयोजन करता है तथा उनका मनुष्य एवं पदार्थों के साथ सामञ्जस्य स्थापित करता है । यह वास्तुसम्मत भवनों में रहने वाले प्राणियों के स्वास्थ्य, धन-धान्य, प्रसन्नता एवं समृद्धि के लिए कार्य करता है । ऋग्वेद के एक मंत्र में वैदिक-ऋषि वास्तोष्पति से अपने संरक्षण में रखने तथा समृद्धि से रहने का आशीर्वाद प्रदान करने हेतु प्रार्थना करता है । ऋषि अपने द्विपदों (मनुष्यों) तथा चतुष्पदों (पशुओं) के लिए भी वास्तोष्पति से कल्याणकारी आशीर्वाद की कामना करता है । यथा –</p>
            <p><strong>वास्तोष्पते प्रति जानीह्यस्मान्त्स्वावेशो अनमीवो भवा नः ।</strong></p>
            <p><strong>यत् त्वेमहे प्रति तन्नो जुषस्व शं नो भव द्विपदे शं चतुष्पदे ।। ऋग्वेद - 7/54/1</strong></p>
            <p>स्थापत्य शास्त्र की परम्परा अथर्ववेद के उपवेद स्थापत्यवेद से प्रारम्भ होकर पौराणिक काल में अपने समृद्धतम अवस्था को प्राप्त हुई । मत्स्यपुराण में भृगु, अत्रि, वसिष्ठ, विश्वकर्मा, मय, नारद, नग्नजित्, विशालाक्ष, पुरन्दर, ब्रह्मा, कुमार, नन्दीश, शौनक, गर्ग, वासुदेव, अनिरुद्ध, शुक्र एवं बृहस्पति स्थापत्यशास्त्र के 18 उपदेष्टा आचार्य कहे गए हैं । इन आचार्यों में विश्वकर्मा नागर परम्परा तथा मय द्राविड़ परम्परा के शीर्ष आचार्य माने जाते हैं । इसके अतिरिक्त अग्निपुराण, गरुड़पुराण, विष्णुधर्मोत्तरपुराण आदि में तथा गृह्यसूत्रों में, आगमग्रन्थों में, तन्त्रसमुच्चय आदि तान्त्रिकग्रन्थों में, बृहत्संहिता आदि ज्योतिषशास्त्रीयग्रन्थों में स्थापत्य का पर्याप्त वर्णन मिलता है ।</p>
            <p>आदिकाव्य रामायण में लंका का राजमहल एवं अशोकवाटिका प्रभृति सुन्दर रचनाएं प्राप्त होती हैं । महाभारत में इन्द्रप्रस्थ नगर, सभा भवन, विश्वकर्मा द्वारा रचित द्वारिकापुरी, कौरवों द्वारा बनाया गया लाक्षागृह जैसे भवनों का वर्णन मिलता है । पुरातात्विक साहित्य के आधार पर सिन्धूघाटी सभ्यता की नगरनिर्माणयोजना पुरातत्वविदों के लिए आश्चर्य का विषय है तथा मौर्यकालीन भवन व सुदर्शन झील का वर्णन भी इतिहास प्रसिद्ध है । प्राचीन हिन्दूशासकों के सुन्दर राजमहल व दुर्गों सहित बृहत्तर भारत के विभिन्न मन्दिर, मध्यकालीन राजपूत राजाओं के किले आदि हमें हमारे समृद्ध स्थापत्य परम्परा के अतीत का ज्ञान करवाते हैं । अतः भारतीय ज्ञान परम्परा में न केवल अध्यात्म अपितु कला, विज्ञान एवं तकनीकी का भी विस्तार से वर्णन प्राप्त होता है ।</p>
            <p>आगे चलकर स्थापत्यशास्त्र के स्वतंत्र ग्रन्थों की रचना हुई । इनमें विश्वकर्मप्रकाश, अपराजितपृच्छा, जयपृच्छा, मानसार, प्रमाणमंजरी, विश्वकर्मावास्तुशास्त्र, प्रासादमण्डन, वास्तुरत्नाकर, वास्तुसार, बृहद्वास्तुमाला, वास्तुरत्नावली, राजवल्लभवास्तुशास्त्र, वास्तुमण्डनम्, समराङ्गणसूत्रधार, देवालयचन्द्रिका, मनुष्यालयचन्द्रिका, रूपमण्डनम्, मयमतम् आदि ग्रन्थ भारतीय स्थापत्य परम्परा पर आधारित प्रमुख ग्रन्थ हैं । इन ग्रन्थों में भारतीय स्थापत्य परम्परा का विस्तार से वर्णन किया गया है ।</p>
            <p>जीवन पद्धति को सुलभ एवं सरल बनाने में वास्तुशास्त्र विशेष रूप से सहायक है । भारतीय सनातन परम्परा में गृहनिर्माण प्रत्येक मनुष्य के लिए आवश्यक माना गया है, घर के विना गृहस्थाश्रम पूर्ण नहीं हो सकता । गृहस्थ आश्रम का मूल ही गृह है । अतः प्रत्येक मनुष्य इस कार्य को करता ही है और आवश्यक भी है कि गृह वास्तुशास्त्रीय नियमों के अनुसार हो । वर्तमान में दौड़भाग भरे इस जीवन में आराम के लिए घर की आवश्यक है, जहां मनुष्य अपनी व्यस्तता भरी जीवन की सारी थकावट भूलकर शान्ति से विश्राम कर सके । वह घर सुख एवं समृद्धिप्रदायक हो, जहां पारिवारिक सामञ्जस्य हो, भौतिक दृष्टि से भी वह घर समृद्ध हो, पञ्चमहाभौतिक तत्वों का वहां समावेश अच्छे से हो, अतः इन सभी की प्राप्ति हेतु आवश्यक है कि गृहनिर्माण वास्तुशास्त्रीय सिद्धान्तों के आधार पर किया जाए ।</p>
            <p>वर्तमान में विद्यार्थियों को वास्तुशास्त्रीय सिद्धान्तों के अध्ययन के लिए महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल में वास्तुशास्त्र डिप्लोमा संचालित है, परन्तु निकट भविष्य में इसके विस्तार और प्राचीन भारतीय मूर्तिकला, स्थापत्यकला, डिजाइनिंग, चित्रकला आदि के साथ-साथ आधुनिक वास्तुकला का भी समावेश इसके अन्तर्गत करने और विश्वविद्यालय में वास्तुशास्त्र विभाग स्थापित करने की योजना है।</p>
        </>
    ),
    "objectives": (
        <>
            <h6>उद्देश्य:</h6>
            <ol>
                <li>वास्तुशास्त्र के सिद्धांतों का ज्ञान: छात्रों को वास्तुशास्त्र के मूल सिद्धांतों, दिशाओं, पंचतत्वों और ऊर्जा के प्रवाह के बारे में जानकारी देना।</li>
                <li>इमारतों और घरों की डिज़ाइन में सामंजस्य: छात्रों को यह सिखाना कि कैसे वास्तुशास्त्र का पालन करके घर और इमारतें सुखद, समृद्ध और स्वास्थ्यपूर्ण वातावरण प्रदान कर सकती हैं।</li>
                <li>प्राकृतिक संसाधनों का उपयोग: प्राकृतिक संसाधनों और वातावरण के साथ सामंजस्यपूर्ण तरीके से निर्माण के बारे में छात्रों को प्रशिक्षित करना।</li>
                <li>आधुनिक वास्तुकला में वास्तुशास्त्र का समावेश: छात्रों को यह सिखाना कि कैसे आधुनिक वास्तुकला और डिज़ाइन में वास्तुशास्त्र के सिद्धांतों को सम्मिलित किया जा सकता है।</li>
                <li>वास्तुशास्त्र के प्रभावों की समझ: भवनों और अन्य संरचनाओं के स्वास्थ्य, समृद्धि और मानसिक शांति पर वास्तुशास्त्र के प्रभावों को समझाना।</li>
                <li>व्यावसायिक कौशल का विकास: छात्रों को व्यावसायिक और तकनीकी कौशल प्रदान करना, ताकि वे वास्तुशास्त्र के क्षेत्र में कार्य करने के लिए तैयार हो सकें, चाहे वह डिज़ाइन, सलाहकार, या निर्माण से संबंधित हो।</li>
            </ol>
            <p>यह डिप्लोमा पाठ्यक्रम विशेष रूप से उन लोगों के लिए उपयुक्त है, जो वास्तुकला, निर्माण, और डिज़ाइन के क्षेत्र में रुचि रखते हैं, और जो भारतीय पारंपरिक वास्तुकला के सिद्धांतों को समझकर इसे अपने कार्यों में उपयोग करना चाहते हैं।</p>
            <p>डॉ. गोविन्द वल्लभ</p>
            <p>समन्वयक, वास्तुशास्त्र डिप्लोमा</p>
        </>
    ),
    "timetable": (
        <>
            <p>सामग्री उपलब्ध नहीं है।</p>
        </>
    ),
    "achievements": (
        <>
            <p>सामग्री उपलब्ध नहीं है।</p>
        </>
    ),
    "contact": (
        <>
            <p>डॉ. गोविन्द वल्लभ</p>
            <p>समन्वयक, वास्तुशास्त्र डिप्लोमा</p>
            <p>मोबाइल – 70115-04209</p>
            <p>ईमेल – govindballabh92k@gmail.com</p>
        </>
    )
};

export default function VastuShastraDiploma() {
    const [showSidebar, setShowSidebar] = useState(true);
    // Changed activeIndex to activeId for consistency with department IDs
    const [activeId, setActiveId] = useState(departments[0].id);
    const [currentContent, setCurrentContent] = useState(contentData[departments[0].id]); // Set default content

    // Effect to handle sidebar visibility on window resize for larger screens
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) { // Bootstrap's md breakpoint
                setShowSidebar(true);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleItemClick = (deptId) => {
        setActiveId(deptId);
        setCurrentContent(contentData[deptId]);
        // Close sidebar on item click for small screens only
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn btn-primary d-md-none m-2"
                onClick={() => setShowSidebar(!showSidebar)}
            >
                ☰ मेनू
            </button>

            {/* Sidebar */}
            <aside
                className={`p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}
                style={{ backgroundColor: '#f8f9fa', overflowY: 'auto' }} // Added overflowY: 'auto' for sidebar
            >
                <h5 className="text-center fw-bold mb-3 text-dark">वास्तुशास्त्र डिप्लोमा</h5>
                <div className="flex-grow-1">
                    {departments.map((dept) => (
                        <p
                            key={dept.id} // Use dept.id as key for better practice
                            className={`mb-1 p-2 rounded shadow-sm small cursor-pointer ${activeId === dept.id
                                ? "bg-primary text-white"
                                : "bg-white text-dark"
                                }`}
                            onClick={() => handleItemClick(dept.id)}
                            style={{ cursor: "pointer" }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main
                className="flex-grow-1 p-3 bg-white shadow col-md-9 overflow-auto" // Added overflow-auto for main content
                onClick={() => {
                    if (window.innerWidth < 768 && showSidebar) { // Only hide if sidebar is visible and on small screens
                        setShowSidebar(false);
                    }
                }}
            >
                <h5></h5>
                <div>{currentContent}</div> {/* Display content from state */}
            </main>
        </div>
    );
}